import { holidays } from '@hedgit/lib/enums/holidays'

export const isTodayHolidayOrWeekend = () => {
  const today = new Date()
  const dayOfWeek = today.getDay()
  // Sunday, Saturday: 0, 6
  const isWeekend = dayOfWeek === 0 || dayOfWeek === 6
  const isHoliday = holidays.includes(today.toISOString().split('T')[0])
  return isWeekend || isHoliday
}
